import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTourData } from '../data/tour-data';
import { TourEvidencePanel } from '../components/TourEvidencePanel';

export function TourConversationPage() {
  const fixture = useTourData();
  const assistantMessages = fixture.conversation.messages.filter((message) => message.role === 'ASSISTANT');
  const [selectedMessageId, setSelectedMessageId] = useState(assistantMessages[0]?.message_id ?? '');
  const selected = useMemo(() => fixture.conversation.messages.find((message) => message.message_id === selectedMessageId), [fixture, selectedMessageId]);

  return (
    <section className="r42-tour-conversation-page">
      <header className="r42-work-head r42-tour-conversation-head">
        <div><span className="r42-eyebrow">Machine conversation</span><h1>{fixture.conversation.title}</h1><p>Machine: {fixture.machine.machine_name}</p></div>
        <span className="r42-intel-status"><i className="bi bi-shield-check" aria-hidden="true" /> Grounded example</span>
      </header>

      <div className="r42-tour-conversation-layout">
        <main className="r42-tour-thread" aria-label="Example conversation">
          {fixture.conversation.messages.map((message) => (
            <article key={message.message_id} data-tour-target={message.sequence === 1 ? 'machine-question' : undefined} className={`r42-tour-message r42-tour-message--${message.role.toLowerCase()}`}>
              <div className="r42-tour-message__meta">
                <strong>{message.role === 'USER' ? 'Operator' : 'Route42'}</strong>
                <time>{new Date(message.created_at).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}</time>
              </div>
              <p>{message.text}</p>
              {message.role === 'ASSISTANT' && message.evidence_claim_ids.length ? (
                <button type="button" className={`r42-tour-evidence-button${selectedMessageId === message.message_id ? ' is-active' : ''}`} onClick={() => setSelectedMessageId(message.message_id)}>
                  <i className="bi bi-journal-check" aria-hidden="true" /> View {message.evidence_claim_ids.length} supporting claims
                </button>
              ) : null}
            </article>
          ))}

          <div className="r42-tour-conversation-next">
            <div><span className="r42-eyebrow">The important outcome</span><strong>Route42 confirms the symptom, but refuses to invent the cause.</strong><p>The unresolved mechanism becomes durable investigation work instead of disappearing into chat.</p></div>
            <Link className="btn r42-btn-primary" to="/tour/investigation">Open the Investigation</Link>
          </div>

          <div className="r42-tour-composer-mock" aria-label="Read-only example composer">
            <span>Ask another question about this machine…</span>
            <button type="button" disabled aria-label="Example is read-only"><i className="bi bi-arrow-up" /></button>
            <small>The guided example is read-only. In your workspace, this is where you ask the machine follow-up questions.</small>
          </div>
        </main>

        <div data-tour-target="grounded-answer">
        <TourEvidencePanel
          fixture={fixture}
          claimIds={selected?.evidence_claim_ids ?? []}
          title={selected ? `Evidence for Route42 message ${selected.sequence}` : 'Evidence behind this'}
        />
        </div>
      </div>
    </section>
  );
}
